import { Drawer } from 'antd';
import './styles.scss';
import DrawerHeader from '../Drawer-header/DrawerHeader';
import DrawerContent from '../Drawer-content/DrawerContent';
import DrawerFooter from '../Drawer-footer/DrawerFooter';

interface FeedbackDrawerProps {
  open?: any;
  onClose?: any;
  onSkip?: any;
  onSubmit?: any;
  updateLoading?: any;
}

function FeedbackDrawer({
  open,
  onClose,
  onSkip,
  onSubmit,
  updateLoading,
}: FeedbackDrawerProps) {
  return (
    <div className="my-div">
      <Drawer
        rootClassName="feedback-drawer"
        maskClosable={false}
        style={{ borderRadius: '8px 0px 0px 8px' }}
        className="relative"
        headerStyle={{ border: 'none' }}
        placement="right"
        onClose={onClose}
        open={open}
        closable={false}
        footer={
          <DrawerFooter
            updateLoading={updateLoading}
            handleSkip={onSkip}
            onSubmit={onSubmit}
          />
        }
      >
        <DrawerHeader handleClose={onClose} />
        <DrawerContent />
      </Drawer>
    </div>
  );
}

export default FeedbackDrawer;
